<template>
  <div>
    <div class="d-flex justify-space-between align-center mt-2 mb-3">
      <h6 class="mb-0">Cupons</h6>
      <v-btn
        v-if="!party.techniciansOnly || user.MasterPermission"
        @click="addCoupon"
        color="primary"
        :small="$vuetify.breakpoint.mdAndDown"
      >
        <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-plus</v-icon>
        <template v-if="$vuetify.breakpoint.smAndUp">Cupom</template>
      </v-btn>
    </div>

    <tecnician-only-message v-if="party.techniciansOnly" class="mt-2 mb-2" />

    <v-expansion-panels focusable v-model="expanded">
      <coupon-management-item
        v-for="(coupon, i) in sortedCoupons"
        :key="coupon.id"
        :coupon="coupon"
        :expanded="expanded === i"
        :party="party"
      />
    </v-expansion-panels>

    <coupon-modal :party="party" @refresh="getCoupons" />
    <edit-coupon-modal :party="party" @refresh="getCoupons" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import COUPON from "@/services/admin/party/coupon";
import CouponModal from "./coupon/CouponModal.vue";
import CouponManagementItem from "./coupon/CouponManagementItem.vue";
import EditCouponModal from "./coupon/EditCouponModal.vue";
import TecnicianOnlyMessage from "@/components/global/tecnician/TecnicianOnlyMessage.vue";
export default {
  components: {
    CouponModal,
    CouponManagementItem,
    EditCouponModal,
    TecnicianOnlyMessage,
  },
  data: () => ({
    coupons: [],
    expanded: null,
    loading: false,
  }),
  methods: {
    async getCoupons() {
      try {
        const { coupons } = await COUPON.getAll(
          this.party.organizationId,
          this.party.id
        );
        this.coupons = coupons;
      } catch (error) {
        console.error(error);
      }
    },

    addCoupon() {
      this.$root.$emit("coupon-modal");
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    sortedCoupons() {
      return this.coupons.sort((a, b) => {
        if (a.validUntil && b.validUntil) return b.validUntil - a.validUntil;

        if (a.validUntil) return 1;
        else return -1;
      });
    },
  },
  mounted() {
    this.getCoupons();
  },
  props: {
    party: Object,
  },
};
</script>

<style></style>
